export default "__VITE_ASSET__Dq2db4Pw__"